/**
 * Delay status canonical map.
 * Used in delays table cell, drawer active-delay alert, and delays listing filter.
 */

export type DelayStatus = 'received' | 'escalated' | 'resolved' | 'not_resolved'

export interface DelayStatusInfo {
    label: string
    color: string
}

/** Кольори — hex, як в AssignmentStatus: їх читає Ship StatusBadge (пігулка з крапкою) */
export const DELAY_STATUS_MAP: Record<DelayStatus, DelayStatusInfo> = {
    received: { label: 'Отримано', color: '#faad14' },
    escalated: { label: 'Ескальовано', color: '#ff4d4f' },
    resolved: { label: 'Вирішено', color: '#52c41a' },
    not_resolved: { label: 'Не вирішено', color: '#fa541c' },
}

/** Опція бейджа/селекта за статусом затримки; невідомий статус — сірий бейдж з кодом */
export const delayStatusOption = (status: string | undefined) => {
    const info = status ? DELAY_STATUS_MAP[status as DelayStatus] : undefined
    return info ? { value: status as string, label: info.label, color: info.color } : undefined
}

/** Джерело затримки — звідки вона потрапила в систему. */
export type DelaySource = 'driver_app' | 'wialon'

export const DELAY_SOURCE_MAP: Record<DelaySource, DelayStatusInfo> = {
    driver_app: { label: 'Додаток водія', color: 'blue' },
    wialon: { label: 'Wialon', color: 'geekblue' },
}
